import { AddressRecipientType } from '../models/address.model'

export const ADDRESS_RECIPIENT_TYPES: {
  code: AddressRecipientType
  name: string
}[] = [
  {
    code: 'CUSTOMER',
    name: 'Cliente',
  },
  {
    code: 'WAREHOUSE',
    name: 'Magazzino',
  },
  {
    code: 'PICKUP_POINT',
    name: 'Pickup Point',
  },
]

export const ADDRESS_RECIPIENT_TYPES_NG: {
  value: AddressRecipientType
  label: string
}[] = [
  {
    label: 'Cliente',
    value: 'CUSTOMER',
  },
  {
    label: 'Magazzino',
    value: 'WAREHOUSE',
  },
  {
    label: 'Pickup Point',
    value: 'PICKUP_POINT',
  },
]
